import React from 'react';
import { Router } from '@reach/router';
import DashboardContext from '../../contexts/DashboardContext';
import keyBy from 'lodash/keyBy';
import HomePage from './HomePage';

const MyTeamPage = React.lazy(() => import('./MyTeamPage'));
const ShopTalkPage = React.lazy(() => import('./ShopTalkPage'));
// const PlanPage = React.lazy(() => import('./PlanPage'));
const PromotionsPage = React.lazy(() => import('./PromotionsPage'));
const SettingsPage = React.lazy(() => import('./SettingsPage'));
const WabPage = React.lazy(() => import('./WabPage'));
const MyResultsPage = React.lazy(() => import('./MyResultsPage'));
const ProfilePage = React.lazy(() => import('./ProfilePage'));
const YoupreneurPage = React.lazy(() => import('./YoupreneurPage'));
const BrainBank = React.lazy(() => import('./BrainBank'));

export default function Routes() {
  const { state } = React.useContext(DashboardContext);
  const { pages } = state.context;
  const pageMap = React.useMemo(() => keyBy(pages, 'key'), [pages]);
  if (!pageMap) return 'Loading..';
  return (
    <React.Suspense fallback={<span>Loading..</span>}>
      <Router primary={false}>
        <ShopTalkPage path={`/${pageMap['shop-talk'].path}/*`} />
        <HomePage path={`/${pageMap.home.path}/*`} />
        <MyTeamPage path={`/${pageMap['my-team'].path}/*`} />
        {/* <PlanPage path={`/${pageMap.plan.path}/*`} /> */}
        <BrainBank path={`/${pageMap['brain-bank'].path}/*`} />
        <PromotionsPage path={`/${pageMap.promotions.path}/*`} />
        <SettingsPage path={`/${pageMap.settings.path}/*`} />
        <WabPage path={`/${pageMap.wab.path}/*`} />
        <MyResultsPage path={`/${pageMap['my-results'].path}/*`} />
        <ProfilePage path={`/${pageMap.profile.path}/*`} />
        <YoupreneurPage path={`/${pageMap.youpreneur.path}/*`} />
      </Router>
    </React.Suspense>
  );
}
